import i18n from 'i18next'

import { createFileRoute, redirect } from '@tanstack/react-router'

import { ApiCaller } from '@graphit/callers'

import { meQueryOptions } from '~/queries/me'
import { workspacesQueryOptions } from '~/queries/workspaces'

export const Route = createFileRoute('/_authed/workspaces/')({
	loader: async ({ context }) => {
		const [workspaces, me] = await Promise.all([
			context.queryClient.ensureQueryData(workspacesQueryOptions),
			context.queryClient.ensureQueryData(meQueryOptions)
		])

		if (workspaces.length > 0) {
			const lastId = me.lastViewedWorkspaceId
			const target = (lastId && workspaces.find(w => w.id === lastId)) || workspaces[0]
			throw redirect({ to: '/workspaces/$id', params: { id: target.id } })
		}

		const workspace = await ApiCaller.createWorkspace(i18n.t('workspace/workspace:new_workspace'))
		context.queryClient.setQueryData(workspacesQueryOptions.queryKey, [workspace])
		throw redirect({ to: '/workspaces/$id', params: { id: workspace.id } })
	}
})
